// Entry point for Create React App
// This file imports and executes the main app setup from the new structure
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import logger, { createLogger } from './shared/config/logger';
import { Providers } from './app/providers';
import { store } from './shared/store';
import { redirectEmailConfirmationToConfirmPage } from './features/auth/utils/emailConfirmationRedirect';
// Token injection now handled in store.js

redirectEmailConfirmationToConfirmPage();

const log = createLogger('index.js');

// App startup is informational — only show it when verbose logging is enabled.
log.debug('Application starting', {
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV,
});

// Persisting every log to localStorage is opt-in. Set
// REACT_APP_LOG_PERSIST=true to capture logs across page reloads while
// debugging.
if (process.env.REACT_APP_LOG_PERSIST === 'true') {
    logger.enablePersistence();
    log.debug('Log persistence enabled');
}

// Set up global error handler
window.addEventListener('error', (event) => {
    log.error('Unhandled error', {
        message: event.error?.message || event.message,
        stack: event.error?.stack,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
    });
});

// Set up unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
    log.error('Unhandled promise rejection', {
        message: event.reason?.message || 'Unknown promise rejection',
        stack: event.reason?.stack,
        reason: event.reason,
    });
});

// Token injection now handled in store.js via setTokenGetter

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Providers store={store}>
            <App />
        </Providers>
    </React.StrictMode>
);

// Configure reportWebVitals to use our logger
reportWebVitals(({ name, value }) => {
    log.debug('Web Vital', { name, value });
});
